import { useNavigate } from "react-router-dom";
import { Alert, Button, Col, Row, Spinner } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiDomain, mdiCardRemoveOutline } from "@mdi/js";
import { useInfiniteQuery } from "react-query";

import { PageSize, SkeletonCount } from "../../config/defines";
import { getEmpresasListar, getGetEmpresasListarQueryKey } from "../../config/swagger";

import InfiniteScroll from "../../components/InfiniteScroll";
import EmpresasCard from "../../components/EmpresasCard";
import Layout from "../../components/Layout";

export default function Empresas() {
	const navigate = useNavigate();

	const query = useInfiniteQuery(getGetEmpresasListarQueryKey({ offset: 0, limit: PageSize }), ({ pageParam = 0 }) => getEmpresasListar({ offset: pageParam * PageSize, limit: PageSize }), {
		getNextPageParam: (lastPage, allPages) => (lastPage.Data?.length === PageSize ? allPages.length : null),
	});

	return (
		<Layout>
			<h5 className="mt-4 mb-4 d-flex align-items-center fw-light">
				<Icon path={mdiDomain} size={1} className="me-2" /> Empresas
				{query.isRefetching && <Spinner size="sm" className="ms-1" variant="secondary" />}
				<div className="float-right ms-auto" style={{ marginTop: -10, marginBottom: -10 }}>
					<Button
						variant="primary"
						className="rounded-3 shadow-sm"
						onClick={() => {
							navigate("/empresaFormulario");
						}}
					>
						Cadastrar
					</Button>
				</div>
			</h5>

			<Row className="mb-4">
				{query.isLoading &&
					Array.from({ length: Number(SkeletonCount) }, (_, index) => {
						return (
							<Col md={12} key={index}>
								<EmpresasCard skeleton />
							</Col>
						);
					})}
				{!query.isLoading && query.isError && (
					<Col md={12}>
						<Alert variant="secondary" className="text-center">
							Problema na operação. Tente novamente mais tarde
						</Alert>
					</Col>
				)}
				{!query.isLoading && query.data?.pages[0].Data && query.data.pages[0].Data.length === 0 && (
					<Col md={12}>
						<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
							<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
							Nenhum registro encontrado
						</Alert>
					</Col>
				)}
				{!query.isLoading &&
					query.data?.pages.map((dataPage, dataPageIndex) => {
						return (
							dataPage?.Data &&
							dataPage?.Data.length >= 1 &&
							dataPage?.Data.map((item) => {
								return (
									<Col md={12} key={item.id}>
										<EmpresasCard data={item} />
									</Col>
								);
							})
						);
					})}
				<Col md={12} className="text-center">
					<InfiniteScroll
						more={query.hasNextPage}
						loading={query.isFetchingNextPage}
						loader={<EmpresasCard skeleton />}
						load={() => {
							query.fetchNextPage();
						}}
					/>
				</Col>
			</Row>
		</Layout>
	);
}
